import React, { useState, useRef, useEffect } from 'react';
import Style from './mobile-collapse.less';

interface CollapseItemProps {
    title: React.ReactNode;
    content: React.ReactNode;
    isOpen: boolean;
    collapsible: boolean;
    onClick: () => void;
}

const CollapseItem: React.FC<CollapseItemProps> = ({ title, content, isOpen, collapsible, onClick }) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [height, setHeight] = useState<string | number>(0);

    useEffect(() => {
        if (isOpen) {
            setHeight(contentRef.current?.scrollHeight || 'auto');
        } else {
            setHeight(0);
        }
    }, [isOpen]);

    useEffect(() => {
        if (isOpen) {
            setHeight(contentRef.current?.scrollHeight || 'auto');
        }
    });

    return (
        <div className={Style['collapse-item']}>
            <div className={Style['collapse-title']} onClick={collapsible ? onClick : undefined}>
                {title}
            </div>
            {
                collapsible
                && <div className={Style['collapse-content']} style={{ height }}>
                    <div ref={contentRef} className={Style['collapse-content-inner']}>
                        {content}
                    </div>
                </div>
            }
        </div>
    );
};

interface CollapseProps {
    items: { title: React.ReactNode; content: React.ReactNode; collapsible: boolean }[];
}

const Collapse: React.FC<CollapseProps> = ({ items }) => {
    const [openIndex, setOpenIndex] = useState<number | null>(null);

    const handleItemClick = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <div className={Style['collapse-container']}>
            {items.map((item, index) => (
                <CollapseItem
                    key={index}
                    title={item.title}
                    content={item.content}
                    isOpen={openIndex === index}
                    collapsible={item.collapsible}
                    onClick={() => handleItemClick(index)}
                />
            ))}
        </div>
    );
};

export default Collapse;
